<script lang="ts" setup>
import { asset } from 'laravel-vapor';
import { Head } from '@inertiajs/vue3';
import { Card, CardHeader, CardIcon, CardSection, CardTitle, Link } from '@returnless/focus-ui';

defineProps<{
  requestId?: string;
  status: string | number;
  title: string;
}>();
</script>

<template>
  <Head>
    <title>{{ title }}</title>
  </Head>

  <div class="w-screen h-screen flex items-center justify-center bg-slate-50">
    <div class="mx-auto max-w-md w-full text-sm">
      <Card>
        <CardHeader>
          <CardIcon
            :source="asset('img/favicon_light.svg')"
            alt="Returnless"
          />
          <CardTitle>{{ title }}</CardTitle>
        </CardHeader>
        <CardSection>
          <slot />
        </CardSection>
      </Card>

      <div class="flex pl-6 mt-4 space-x-4">
        <Link
          external
          href="https://www.returnless.com"
        >
          Homepage
        </Link>

        <Link
          external
          href="mailto:support@returnless.com"
        >
          Contact support
        </Link>
      </div>
    </div>
  </div>
</template>
